import { GlobalResponseObject } from '@schemax-whatsapp/shared-models';
import { ApplicationModel } from './company-module-model';

export class ApplicationResponse extends GlobalResponseObject {
    data?: ApplicationModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ApplicationModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}